import { api } from '@/lib/api'

import { ContractorDetails } from '../types'

type UpdateContractorRequest = {
  contractorId: string
  firstName: string
  lastName: string
  secondLastName?: string
  email: string
  internationalPhonePrefix: string
  localPhoneNumber: string
  dateOfBirth: string
  residentialAddress: {
    addressStreet: string
    addressStreetNumber: string
    addressDistrict?: string
    addressCity: string
    addressState: string
    addressPostCode: string
    addressCountry: string
  }
}

export const updateContractor = (data: UpdateContractorRequest) => {
  return api.patch<ContractorDetails>(
    `/v1/me/contractors/${data.contractorId}`,
    data,
  )
}
